import React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Imagini – suprafețe vitrate
import vitrata1 from "assets/images/poze-site/9-1-vitrate.webp";
import vitrata2 from "assets/images/poze-site/9-2-vitrate.webp";
import vitrata3 from "assets/images/poze-site/9-3-vitrate.webp";
import vitrata4 from "assets/images/poze-site/9-4-vitrate.webp";
import vitrata5 from "assets/images/poze-site/9-5-vitrate.webp";
import vitrata6 from "assets/images/poze-site/9-6-vitrate.webp";
import vitrata7 from "assets/images/poze-site/9-7-vitrate.webp";
import vitrata8 from "assets/images/poze-site/9-8-vitrate.webp";
import vitrata9 from "assets/images/poze-site/9-9-vitrate.webp";

const images = [
    vitrata1,
    vitrata2,
    vitrata3,
    vitrata4,
    vitrata5,
    vitrata6,
    vitrata7,
    vitrata8,
    vitrata9,
];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Curățarea suprafețelor vitrate
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport uniform (păstrează toate imaginile la aceleași dimensiuni vizuale)
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Curățare vitrate ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: index === 4 ? "center 35%" : "center",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
